
module.exports = {
    moving_heads: `Moving Heads & Stage Lighting`,

    fixtures: `Event Lighting Fixtures`,

    gobo: `GOBOs / Monograms`,

    up_lighting: `Up Light Rentals & Wedding Lighting`,

    truss: `Stage Truss Rentals`,
    trusssub: `Box Truss & Truss Structures`,

    stage_risers: `Stage Risers & Platforms`,

    stage_bundles: `Stage Rentals`,

    drape: `Pipe & Drape / Backdrop`,


    'dj-equipment_mixers': `DJ Mixers`,

    'band-equipment_mixers':`Analog Mixers`,

    'band-equipment_bundle':`Band Equipment Bundles`,
    
    'dj-equipment_bundle': `Full DJ Setup Bundles`,

    'lighting_bundle': `Event Lighting Bundles`,

    cdjs: `Pioneer CDJ Rentals`,

    turntables: `DJ Turntables`,

    booth: `DJ Booths & Facades`,

    effects: `DJ Effect Units`,

    sound_microphones: `Microphone Rentals - Wireless, Gooseneck, Lav`, 

    'dj-equipment_microphones': `DJ Microphones`,

    'band-equipment_microphones': `Band Microphones`,
    
    main_speakers: `Main Speaker Rentals - Powered Loudspeakers`,

    microphone_and_speaker : `Microphone and Speaker Rentals`,

    subwoofer:`Subwoofers`,

    monitors: `Powered Monitors`,

    array: `Line Array Speakers`,
    
    recorders: `Recorders`,

    amplifiers: `Passive Speaker Amplifiers`,

    co2_cannon: `CO2 Cannon / Cryo Gun Rentals`,

    fog_machine: 'Fog Machine',

    cold_sparks: `Cold Spark Machines`,

    tvs: `Flat Screen TV Rentals`,

    led_panels: `LED Display / Video Walls`,

    projector: `Projector & Screen Rentals`



}